import React, { useCallback, useEffect, useState } from 'react';
import { useApiAuth } from '../../hooks/useApiAuth';

export default function TestimonialsManager({ setStatus }) {
  const { authFetch } = useApiAuth();
  const [busy, setBusy] = useState(false);
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: '', role: '', body: '', rating: 5 });

  const load = useCallback(async () => {
    try {
      const data = await authFetch('/api/admin/testimonials');
      setItems(data.items || []);
    } catch (e) { setStatus(`Load error: ${e.message}`); }
  }, [authFetch, setStatus]);

  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!form.name.trim() || !form.body.trim()) { setStatus('Name and body required.'); return; }
    setBusy(true); setStatus('Adding…');
    try {
      await authFetch('/api/admin/testimonials', { method: 'POST', body: { ...form, rating: Number(form.rating) || 5, visible: true } });
      setForm({ name: '', role: '', body: '', rating: 5 });
      await load();
      setStatus('Added.');
    } catch (e) { setStatus(`Add error: ${e.message}`); }
    setBusy(false);
  };

  const toggle = async (item) => {
    setBusy(true);
    try {
      await authFetch(`/api/admin/testimonials?id=${item.id}`, { method: 'PATCH', body: { visible: !item.visible } });
      await load();
    } catch (e) { setStatus(`Update error: ${e.message}`); }
    setBusy(false);
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this testimonial?')) return;
    setBusy(true);
    try {
      await authFetch(`/api/admin/testimonials?id=${id}`, { method: 'DELETE' });
      await load();
    } catch (e) { setStatus(`Delete error: ${e.message}`); }
    setBusy(false);
  };

  return (
    <div>
      <section className="admin-section">
        <h2>Add a customer review</h2>
        <div className="admin-form">
          <label>Name
            <input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </label>
          <label>Role (optional)
            <input type="text" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} />
          </label>
          <label>What they said
            <textarea rows="3" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} />
          </label>
          <label>Rating (1-5)
            <input type="number" min="1" max="5" value={form.rating} onChange={(e) => setForm({ ...form, rating: e.target.value })} />
          </label>
          <button className="admin-btn admin-btn-primary" disabled={busy} onClick={add}>Add testimonial</button>
        </div>
      </section>

      <section className="admin-section">
        <h2>Customer reviews ({items.length})</h2>
        {items.length === 0 && <p>No testimonials yet.</p>}
        {items.map((t) => (
          <div key={t.id} className="admin-card" style={{ marginBottom: 12 }}>
            <div><strong>{t.name}</strong>{t.role ? ` — ${t.role}` : ''} <span className="admin-muted">({t.rating}/5)</span></div>
            <p>"{t.body}"</p>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="admin-btn" disabled={busy} onClick={() => toggle(t)}>{t.visible ? 'Hide' : 'Show'}</button>
              <button className="admin-btn admin-btn-danger" disabled={busy} onClick={() => remove(t.id)}>Delete</button>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
